var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusSolidXl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 14C0 6.268 6.268 0 14 0c1.57 0 3.08.259 4.49.735C24.02 2.606 28 7.838 28 14c0 7.732-6.268 14-14 14S0 21.732 0 14m16-8v6h6v4h-6v6h-4v-6H6v-4h6V6z"
})));
export default SvgPlusSolidXl;